"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PTxInfo = void 0;
var pstruct_1 = require("../../../../PTypes/PStruct/pstruct.js");
var type_system_1 = require("../../../../type_system/index.js");
var PValue_1 = require("../../../V1/Value/PValue/index.js");
var Time_1 = require("../../../V1/Time/index.js");
var PPubKeyHash_1 = require("../../../V1/PubKey/PPubKeyHash.js");
var PDatumHash_1 = require("../../../V1/ScriptsHashes/PDatumHash.js");
var PTxInInfo_1 = require("../../Tx/PTxInInfo.js");
var PTxOut_1 = require("../../../V2/Tx/PTxOut.js");
var PMaybe_1 = require("../../../../lib/std/PMaybe/PMaybe.js");
var PTxId_1 = require("../../Tx/PTxId.js");
var PVoter_1 = require("../../Governance/PVoter.js");
var PTxOutRef_1 = require("../../Tx/PTxOutRef.js");
var PVote_1 = require("../../Governance/PVote.js");
var PProposalProcedure_1 = require("../../Governance/PProposalProcedure.js");
var PCredential_1 = require("../../../V1/Address/PCredential.js");
var PScriptPurpose_1 = require("../PScriptPurpose/index.js");
var PCertificate_1 = require("../PCertificate.js");
exports.PTxInfo = (0, pstruct_1.pstruct)({
    PTxInfo: {
        inputs: (0, type_system_1.list)(PTxInInfo_1.PTxInInfo.type),
        refInputs: (0, type_system_1.list)(PTxInInfo_1.PTxInInfo.type),
        outputs: (0, type_system_1.list)(PTxOut_1.PTxOut.type),
        fee: type_system_1.int,
        /** mint has no lovelaces entry */
        mint: PValue_1.PValue.type,
        certificates: (0, type_system_1.list)(PCertificate_1.PCertificate.type),
        withdrawals: (0, type_system_1.map)(PCredential_1.PCredential.type, type_system_1.int),
        interval: Time_1.PPOSIXTimeRange.type,
        signatories: (0, type_system_1.list)(PPubKeyHash_1.PPubKeyHash.type),
        redeemers: (0, type_system_1.map)(PScriptPurpose_1.PScriptPurpose.type, type_system_1.data),
        datums: (0, type_system_1.map)(PDatumHash_1.PDatumHash.type, type_system_1.data),
        id: PTxId_1.PTxId.type,
        votes: (0, type_system_1.map)(PVoter_1.PVoter.type, (0, type_system_1.map)(PTxOutRef_1.PTxOutRef.type, PVote_1.PVote.type)),
        proposalProcedures: (0, type_system_1.list)(PProposalProcedure_1.PProposalProcedure.type),
        currentTreasury: (0, PMaybe_1.PMaybe)(type_system_1.int).type,
        treasuryDonation: (0, PMaybe_1.PMaybe)(type_system_1.int).type,
    }
});
